module.exports = __webpack_public_path__ + "img/m-con.fc788f89.jpg";